export default __webpack_public_path__ + "static/media/Leg_right.6bc9752a.svg";